// Mock data for Nusantara Capital.ai website

export const mockData = {
  // Company Information
  company: {
    name: "Nusantara Capital.ai",
    tagline: "Investing in Tomorrow's Intelligence",
    address: "Jl. Tebet Raya No.14 A, South Jakarta, DKI Jakarta 12810, Indonesia",
    email: "walter@sumogroup.com.au",
    whatsapp: "+61 435 833 829",
    equityRange: "USD 85–105M"
  },

  // Team Members
  team: {
    founder: {
      name: "Walter Kaminski",
      position: "Founder & CEO",
      bio: "Seasoned investment professional with over 15 years of experience in AI and blockchain technologies across Southeast Asian markets.",
      image: "https://customer-assets.emergentagent.com/job_nusantara-ai/artifacts/b0tt0i2c_walterkaminski.jpg"
    },
    members: [
      {
        name: "Jackson Wong",
        position: "Chief Technology Officer",
        bio: "Former technology executive with extensive experience in AI research and blockchain development across Asia-Pacific markets.",
        image: null
      },
      {
        name: "Kurniawaty Surjono",
        position: "Managing Partner",
        bio: "Investment banking veteran with deep expertise in fintech and emerging market investments, with particular focus on Indonesian financial technology sector.",
        image: "https://customer-assets.emergentagent.com/job_nusantara-ai/artifacts/ec5ckyub_kurniawatysurjono.jpg"
      }
    ]
  },

  // Company Logo
  logo: {
    url: "https://customer-assets.emergentagent.com/job_nusantara-ai/artifacts/y0t0et3d_nusantaracapitallogo.png",
    alt: "Nusantara Capital.ai Logo"
  },

  // Services/Focus Areas
  services: [
    {
      title: "AI Solutions & Predictive Analytics",
      description: "Investment in cutting-edge artificial intelligence platforms that transform industries through predictive analytics, automated decision-making, and intelligent data processing.",
      icon: "Brain"
    },
    {
      title: "Blockchain Infrastructure & Tokenization",
      description: "Strategic investments in blockchain technologies, cryptocurrency platforms, and tokenization projects that revolutionize traditional financial systems.",
      icon: "Blocks"
    },
    {
      title: "Fintech Platforms for Emerging Markets",
      description: "Focused on financial technology solutions that serve underbanked populations across Southeast Asia, enabling financial inclusion and digital payments.",
      icon: "CreditCard"
    },
    {
      title: "Smart Infrastructure & Automation",
      description: "Investment in IoT, smart city solutions, and automation technologies that enhance efficiency and sustainability in urban environments.",
      icon: "Building"
    }
  ],

  // Images
  images: {
    jakartaSkyline: "https://images.unsplash.com/photo-1679239108020-aca50acd5f00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxKYWthcnRhJTIwc2t5bGluZXxlbnwwfHx8fDE3NTk1MjUzMzJ8MA&ixlib=rb-4.1.0&q=85",
    jakartaNight: "https://images.unsplash.com/photo-1718729362445-51d2da1ee7a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxKYWthcnRhJTIwc2t5bGluZXxlbnwwfHx8fDE3NTk1MjUzMzJ8MA&ixlib=rb-4.1.0&q=85",
    jakartaGolden: "https://images.unsplash.com/photo-1748344342147-eb1db03b9b9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxKYWthcnRhJTIwc2t5bGluZXxlbnwwfHx8fDE3NTk1MjUzMzJ8MA&ixlib=rb-4.1.0&q=85",
    office1: "https://images.unsplash.com/photo-1549637642-90187f64f420?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fHwxNzU5NTI1MzM4fDA&ixlib=rb-4.1.0&q=85",
    office2: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fHwxNzU5NTI1MzM4fDA&ixlib=rb-4.1.0&q=85"
  },

  // Translations
  translations: {
    en: {
      nav: {
        home: "Home",
        about: "About Us",
        services: "Services",
        investor: "Investor Relations",
        contact: "Contact"
      },
      buttons: {
        explore: "Explore Investment Opportunities",
        learnMore: "Learn More",
        downloadPitch: "Download Pitch Deck",
        contactUs: "Contact Us"
      },
      hero: {
        title: "Investing in Tomorrow's Intelligence",
        subtitle: "Leading private equity group specializing in AI, Blockchain, Tokenization, and Fintech investments across Southeast Asia"
      }
    },
    id: {
      nav: {
        home: "Beranda",
        about: "Tentang Kami",
        services: "Layanan",
        investor: "Hubungan Investor",
        contact: "Kontak"
      },
      buttons: {
        explore: "Jelajahi Peluang Investasi",
        learnMore: "Pelajari Lebih Lanjut",
        downloadPitch: "Unduh Deck Presentasi",
        contactUs: "Hubungi Kami"
      },
      hero: {
        title: "Berinvestasi di Kecerdasan Masa Depan",
        subtitle: "Kelompok ekuitas swasta terkemuka yang mengkhususkan diri dalam investasi AI, Blockchain, Tokenisasi, dan Fintech di Asia Tenggara"
      }
    }
  }
};